import { StyledPropType } from 'style-utils/core/core.types';
import { createExtractCssFromProps } from 'style-utils/core/createExtractCssFromProps/createExtractCssFromProps';
import { CSSProperties } from 'styled-components';

export const borderMappedProperties = {
  border: {
    property: 'border',
  },
  borderWidth: {
    property: 'borderWidth',
  },
  borderStyle: {
    property: 'borderStyle',
  },
  borderColor: {
    property: 'borderColor',
    themeKey: 'colors',
  },
  borderRadius: {
    property: 'borderRadius',
  },
  borderTop: {
    property: 'borderTop',
  },
  borderTopLeftRadius: {
    property: 'borderTopLeftRadius',
  },
  borderTopRightRadius: {
    property: 'borderTopRightRadius',
  },
  borderRight: {
    property: 'borderRight',
  },
  borderBottom: {
    property: 'borderBottom',
  },
  borderBottomLeftRadius: {
    property: 'borderBottomLeftRadius',
  },
  borderBottomRightRadius: {
    property: 'borderBottomRightRadius',
  },
  borderLeft: {
    property: 'borderLeft',
  },
  borderX: {
    properties: ['borderLeft', 'borderRight'],
  },
  borderY: {
    properties: ['borderTop', 'borderBottom'],
  },
  borderTopWidth: {
    property: 'borderTopWidth',
  },
  borderTopColor: {
    property: 'borderTopColor',
    themeKey: 'colors',
  },
  borderTopStyle: {
    property: 'borderTopStyle',
  },
  borderBottomWidth: {
    property: 'borderBottomWidth',
  },
  borderBottomColor: {
    property: 'borderBottomColor',
    themeKey: 'colors',
  },
  borderBottomStyle: {
    property: 'borderBottomStyle',
  },
  borderLeftWidth: {
    property: 'borderLeftWidth',
  },
  borderLeftColor: {
    property: 'borderLeftColor',
    themeKey: 'colors',
  },
  borderLeftStyle: {
    property: 'borderLeftStyle',
  },
  borderRightWidth: {
    property: 'borderRightWidth',
  },
  borderRightColor: {
    property: 'borderRightColor',
    themeKey: 'colors',
  },
  borderRightStyle: {
    property: 'borderRightStyle',
  },
  outline: true,
};

export type WithBorderProps = {
  border?: StyledPropType<CSSProperties['border']>;
  borderWidth?: StyledPropType<CSSProperties['borderWidth']>;
  borderStyle?: StyledPropType<CSSProperties['borderStyle']>;
  borderColor?: StyledPropType<CSSProperties['borderColor']>;
  borderRadius?: StyledPropType<CSSProperties['borderRadius']>;
  borderTop?: StyledPropType<CSSProperties['borderTop']>;
  borderTopLeftRadius?: StyledPropType<CSSProperties['borderTopLeftRadius']>;
  borderTopRightRadius?: StyledPropType<CSSProperties['borderTopRightRadius']>;
  borderRight?: StyledPropType<CSSProperties['borderRight']>;
  borderBottom?: StyledPropType<CSSProperties['borderBottom']>;
  borderBottomLeftRadius?: StyledPropType<
    CSSProperties['borderBottomLeftRadius']
  >;
  borderBottomRightRadius?: StyledPropType<
    CSSProperties['borderBottomRightRadius']
  >;
  borderLeft?: StyledPropType<CSSProperties['borderLeft']>;
  borderX?: StyledPropType<CSSProperties['border']>;
  borderY?: StyledPropType<CSSProperties['border']>;
  borderTopWidth?: StyledPropType<CSSProperties['borderTopWidth']>;
  borderTopColor?: StyledPropType<CSSProperties['borderTopColor']>;
  borderTopStyle?: StyledPropType<CSSProperties['borderTopStyle']>;
  borderBottomWidth?: StyledPropType<CSSProperties['borderBottomWidth']>;
  borderBottomColor?: StyledPropType<CSSProperties['borderBottomColor']>;
  borderBottomStyle?: StyledPropType<CSSProperties['borderBottomStyle']>;
  borderLeftWidth?: StyledPropType<CSSProperties['borderLeftWidth']>;
  borderLeftColor?: StyledPropType<CSSProperties['borderLeftColor']>;
  borderLeftStyle?: StyledPropType<CSSProperties['borderLeftStyle']>;
  borderRightWidth?: StyledPropType<CSSProperties['borderRightWidth']>;
  borderRightColor?: StyledPropType<CSSProperties['borderRightColor']>;
  borderRightStyle?: StyledPropType<CSSProperties['borderRightStyle']>;
  outline?: StyledPropType<CSSProperties['outline']>;
};

export const withBorder = createExtractCssFromProps(borderMappedProperties);
